import React, { memo } from "react";
import { withStyles } from "@material-ui/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import styles from './styles/MiniPaletteStyles';
import { withRouter } from "react-router-dom";

/**
 * MiniPalette component optimized with React.memo.
 *
 * Performance Optimization:
 * This component is used in a long list (PaletteList). By wrapping it in React.memo,
 * we prevent 30+ unnecessary re-renders when the parent's state (like the delete dialog)
 * changes, but the palette data remains the same.
 */
const MiniPalette = memo(function MiniPalette(props) {
  const {
    classes,
    paletteName,
    emoji,
    colors,
    handleClick,
    id,
    handleDelete,
    onOpenInGenerator,
    deletable = true,
    editable = true,
  } = props;

  const deletePalette = (e) => {
    e.stopPropagation();
    handleDelete(id);
  };

  const openInGenerator = (e) => {
    e.stopPropagation();
    if (onOpenInGenerator) onOpenInGenerator(id);
  };

  // Keep Enter/Space on the action buttons from bubbling to the card's
  // keydown handler (which would also open the palette view).
  const stopActivationKeys = (e) => {
    if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
  };

  const editPalette = (e) => {
    e.stopPropagation();
    // Editing happens in the generator (carries full metadata for re-save).
    if (onOpenInGenerator) onOpenInGenerator(id);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(id);
    }
  };

  const miniColorBoxes = colors.map((color, i) =>{
    return(
      <div
      className={classes.miniColor}
      style={{backgroundColor:color.color}}
      key={`${color.name}-${i}`}
      />
    )

  });
  return (
    <div
      className={classes.root}
      onClick={() => handleClick(id)}
      onKeyDown={handleKeyPress}
      tabIndex={0}
      aria-label={`View palette: ${paletteName}`}
    >
      {(editable || deletable) && (
        <div className={classes.actionsContainer}>
          {editable && (
            <IconButton
              className={classes.editIcon}
              onClick={editPalette}
              onKeyDown={stopActivationKeys}
              aria-label={`Edit palette: ${paletteName}`}
              size="small"
              style={{ borderBottomLeftRadius: 0 }}
            >
              <EditIcon />
            </IconButton>
          )}
          {deletable && (
            <IconButton
              className={classes.deleteIcon}
              onClick={deletePalette}
              onKeyDown={stopActivationKeys}
              aria-label={`Delete palette: ${paletteName}`}
              size="small"
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      )}
      <div className={classes.colors}>
        {/* Mini COLOR BOXES */}
        {miniColorBoxes}
      </div>
      <h5 className={classes.title}>
        {paletteName}
        <span className={classes.emoji}>{emoji}</span>
      </h5>
      {onOpenInGenerator && (
        <Button
          size="small"
          startIcon={<OpenInNewIcon style={{ fontSize: 16 }} />}
          onClick={openInGenerator}
          onKeyDown={stopActivationKeys}
          aria-label={`Open in generator: ${paletteName}`}
          style={{
            marginTop: '0.4rem',
            padding: '2px 6px',
            textTransform: 'none',
            fontSize: '0.75rem',
            color: '#1976d2',
          }}
        >
          Open in Generator
        </Button>
      )}
    </div>
  );
});

// it is a HOC
export default withRouter(withStyles(styles)(MiniPalette));
